// import Component from './index' ;

export default {
  // component: Component,
  component: load(() => import(/* webpackChunkName: "Poll" */ './index')),
  priority: 400,
  permissions: ['uiPermission','ManagementDecisions1900','ManagementDecisions', 'isNotAdmin'],
  name: app.translate('routes.home.management-decisions.ManagementDecisions'),
  icon: 'apple-keyboard-command',
  drawer: true,
};


